import { h } from 'preact';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Skeleton from '@mui/material/Skeleton';

function CommonColumns(_props) {
  return (
    <>
      <TableCell>
        <Skeleton width={240} />
      </TableCell>
      <TableCell>
        <Skeleton variant="circular" width={24} height={24} />
      </TableCell>
      <TableCell>
        <Skeleton width={10} />
      </TableCell>
      <TableCell>
        <Skeleton variant="circular" width={24} height={24} />
      </TableCell>
    </>
  );
}

export function LazyCruxIssueRecord(_props) {
  return (
    <TableRow hover>
      <CommonColumns />
    </TableRow>
  );
}

export default function LazyCruxUrlRecord(_props) {
  return (
    <TableRow hover>
      <CommonColumns />
      <TableCell>
        <Skeleton width={10} />
      </TableCell>
    </TableRow>
  );
}
